import React, { useState, useEffect } from 'react';
import { Row, Col } from 'antd';
import screenshot1 from '../../assets/images/1.PNG';
import screenshot2 from '../../assets/images/2.PNG';
import screenshot3 from '../../assets/images/3.PNG';
import taylorDark1 from '../../assets/images/dark1.png';
import taylorDark2 from '../../assets/images/dark2.png';
import taylorLight1 from '../../assets/images/light1.png';
import taylorLight2 from '../../assets/images/light2.png';
import taylorLight3 from '../../assets/images/light3.png';

// ── Palette mockup ────────────────────────────────────────────────────────────

const palSwatches = [
  { hex: '#414837', pct: '21%' },
  { hex: '#5d666a', pct: '19%' },
  { hex: '#122114', pct: '16%' },
  { hex: '#096759', pct: '13%' },
  { hex: '#c9dae6', pct: '11%' },
  { hex: '#9b8a9c', pct: '11%' },
  { hex: '#b51830', pct: '5%' },
  { hex: '#86a311', pct: '4%' },
];

const palHarmony = ['#203646','#385f7a','#5087ae','#85abc7','#b9cfdf'];

const palRecent = [
  ['#414837','#5d666a','#096759','#b51830','#86a311'],
  ['#f5a623','#c45e2e','#7a3520','#f0c060','#e8832a'],
  ['#0d2b4e','#2e86c1','#7fb3d3','#a9cce3','#d6eaf8'],
];

function PaletteMockup() {
  return (
    <div className='pal-mockup'>
      {/* Title bar */}
      <div className='pal-titlebar'>
        <div className='pal-dots'>
          <span className='chroma-dot dot-r'></span>
          <span className='chroma-dot dot-y'></span>
          <span className='chroma-dot dot-g'></span>
        </div>
        <span className='pal-title'>CHROMA — COLOR PALETTE EXTRACTOR</span>
        <span className='pal-moon'>☾</span>
      </div>
      {/* Body */}
      <div className='pal-body'>
        {/* Sidebar */}
        <div className='pal-sidebar'>
          <div className='pal-sec-label'>PALETTE</div>
          <div className='pal-nav pal-nav-active'>◈ Extract</div>
          <div className='pal-nav'>⬡ Grid View</div>
          <div className='pal-nav'>▣ List View</div>
          <div className='pal-nav'>◎ Harmonies</div>
          <div className='pal-sec-label'>EXPORT</div>
          <div className='pal-nav'>◇ CSS / HEX</div>
          <div className='pal-nav'>◇ Tailwind</div>
          <div className='pal-sidebar-bottom'>
            <div className='pal-recent-lbl'>RECENT</div>
            {palRecent.map((row, i) => (
              <div key={i} className='pal-recent-row'>
                {row.map((c, j) => (
                  <span key={j} className='pal-recent-dot' style={{ background: c }}></span>
                ))}
              </div>
            ))}
          </div>
        </div>
        {/* Main */}
        <div className='pal-main'>
          {/* Controls */}
          <div className='pal-controls'>
            <div className='pal-stepper'><span>−</span><span className='pal-step-val'>8</span><span>+</span></div>
            <span className='pal-ctrl'>Prominence</span>
            <span className='pal-ctrl'>HEX</span>
            <span className='pal-ctrl'>Grid</span>
            <span className='pal-reextract'>↺ Re-extract</span>
          </div>
          {/* 2×4 swatch grid */}
          <div className='pal-grid'>
            {palSwatches.map((s) => (
              <div key={s.hex} className='pal-swatch'>
                <div className='pal-swatch-color' style={{ background: s.hex }}></div>
                <div className='pal-swatch-hex'>{s.hex}</div>
                <div className='pal-swatch-pct'>{s.pct}</div>
              </div>
            ))}
          </div>
          {/* Color strip */}
          <div className='pal-strip'>
            {palSwatches.map((s) => (
              <div key={s.hex} style={{ background: s.hex, flex: parseFloat(s.pct), height: '100%' }}></div>
            ))}
          </div>
          {/* Harmonies */}
          <div className='pal-harmony'>
            <div className='pal-harmony-hdr'>
              <span className='pal-harmony-title'>COLOR HARMONIES</span>
              <div className='pal-harmony-tabs'>
                <span className='pal-htab'>Complementary</span>
                <span className='pal-htab'>Triadic</span>
                <span className='pal-htab'>Analogous</span>
                <span className='pal-htab pal-htab-active'>Shades</span>
              </div>
            </div>
            <div className='pal-harmony-swatches'>
              {palHarmony.map((c) => (
                <div key={c} className='pal-h-swatch'>
                  <div className='pal-h-color' style={{ background: c }}></div>
                  <div className='pal-h-hex'>{c}</div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

// ── NPZ View mockup ───────────────────────────────────────────────────────────

const npzvArrays = ['EbN0dB', 'BLER_BPSK', 'AE_8x8_bler', 'BLER_neural', 'BLER_hamming_id'];

// Bar heights (%) approximating the screenshot's decreasing distribution
const npzvBars = [92, 72, 56, 44, 36, 28, 22, 17, 13, 10, 8, 6, 4, 3, 2, 2, 1, 1, 0, 0];

const npzvDataRow = ['0.4906','0.4396','0.3745','0.3242','0.2522','0.1987','0.1502','0.1084','0.0751','0.0457','0.0267','0.0182'];

function NpzMockup() {
  return (
    <div className='npzv-mockup'>
      {/* Windows title bar */}
      <div className='npzv-winbar'>
        <div className='npzv-winicon'>NPZ</div>
        <span className='npzv-wintitle'>NPZ File Viewer</span>
        <div className='npzv-wincontrols'>
          <span>─</span><span>□</span><span className='npzv-close'>✕</span>
        </div>
      </div>
      {/* Toolbar */}
      <div className='npzv-toolbar'>
        <span className='npzv-openbtn'>⊞ Open NPZ File</span>
        <span className='npzv-filename'>simulation_results.npz</span>
        <div className='npzv-zoom'>
          <span>?</span><span>−</span><span>100%</span><span>+</span>
        </div>
      </div>
      {/* Body */}
      <div className='npzv-body'>
        <div className='npzv-sidebar'>
          <div className='npzv-sidebar-hdr'>Arrays</div>
          {npzvArrays.map((name) => (
            <div key={name} className={`npzv-array-item${name === 'AE_8x8_bler' ? ' npzv-array-active' : ''}`}>
              {name}
            </div>
          ))}
        </div>
        <div className='npzv-main'>
          <div className='npzv-array-name'>AE_8x8_bler</div>
          <div className='npzv-meta'>
            <div className='npzv-meta-row'><span className='npzv-ml'>Shape:</span><span className='npzv-mv'>[24]</span></div>
            <div className='npzv-meta-row'><span className='npzv-ml'>Dimensions:</span><span className='npzv-mv'>1</span></div>
            <div className='npzv-meta-row'><span className='npzv-ml'>Data Type:</span><span className='npzv-mv'>float64</span></div>
            <div className='npzv-meta-row'><span className='npzv-ml'>Min Value:</span><span className='npzv-mv'>0</span></div>
            <div className='npzv-meta-row'><span className='npzv-ml'>Max Value:</span><span className='npzv-mv'>0.4906</span></div>
            <div className='npzv-meta-row'><span className='npzv-ml'>Mean Value:</span><span className='npzv-mv'>0.10500416…</span></div>
          </div>
          <div className='npzv-chart'>
            <div className='npzv-chart-title'>1D Array: AE_8x8_bler</div>
            <div className='npzv-bars'>
              {npzvBars.map((h, i) => (
                <div key={i} className='npzv-bar' style={{ height: `${h}%` }}></div>
              ))}
            </div>
          </div>
          <div className='npzv-data-hdr'>Array Data<span className='npzv-data-note'>Showing sample data (limited to 100 elements)</span></div>
          <div className='npzv-data-row'>
            {npzvDataRow.map((v, i) => (
              <span key={i} className='npzv-data-cell'>{v}</span>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

// ── Taylor Slideshow ──────────────────────────────────────────────────────────

const taylorImages = [taylorLight1, taylorDark1, taylorLight2, taylorDark2, taylorLight3];

function TaylorSlideshow() {
  const [index, setIndex] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setIndex(i => (i + 1) % taylorImages.length);
    }, 3000);
    return () => clearInterval(timer);
  }, []);

  return (
    <div className='taylor-slideshow'>
      {taylorImages.map((img, i) => (
        <img
          key={i}
          src={img}
          alt='Taylor screenshot'
          className={`taylor-slide${i === index ? ' taylor-slide-active' : ''}`}
        />
      ))}
    </div>
  );
}

// ── AppTools ──────────────────────────────────────────────────────────────────

function AppTools() {
  return (
    <div id='tools' className='block toolsBlock'>
      <div className='container-fluid'>
        <div className='titleHolder'>
          <h2>Professional Tools</h2>
          <p>Useful utilities and visualizers maintained by desi8n. More tools may be added here.</p>
        </div>

        <div className='quickshift-section'>
          <div className='quickshift-preview'>
            <div className='quickshift-screenshots'>
              <img src={screenshot1} alt='QuickShift dashboard' className='quickshift-screenshot' />
              <img src={screenshot2} alt='QuickShift timer' className='quickshift-screenshot' />
              <img src={screenshot3} alt='QuickShift dark mode' className='quickshift-screenshot' />
            </div>
            <div className='quickshift-overlay'>
              <a className='ant-btn ant-btn-primary' href='https://quickshift.desi8n.com' target='_blank' rel='noopener noreferrer'>
                <i className='fas fa-external-link-alt'></i> Open QuickShift
              </a>
            </div>
          </div>
          <div className='quickshift-info'>
            <h3><a href='https://quickshift.desi8n.com' target='_blank' rel='noopener noreferrer'>QuickShift</a></h3>
            <p>All-in-one work tracker for freelancers and consultants. Track time, manage clients and projects, generate invoices, and monitor earnings.</p>
          </div>
        </div>

        <div className='taylor-section'>
          <div className='taylor-preview'>
            <TaylorSlideshow />
            <div className='taylor-overlay'>
              <a className='ant-btn ant-btn-primary' href='https://taylor.desi8n.com' target='_blank' rel='noopener noreferrer'>
                <i className='fas fa-external-link-alt'></i> Open Taylor
              </a>
            </div>
          </div>
          <div className='taylor-info'>
            <h3><a href='https://taylor.desi8n.com' target='_blank' rel='noopener noreferrer'>Taylor</a></h3>
            <p>A beautifully designed tool built for productivity and efficiency, available in both light and dark modes.</p>
          </div>
        </div>

        <Row gutter={[16, 16]}>
          <Col xs={{ span: 24 }} sm={{ span: 12 }} md={{ span: 12 }}>
            <div className='tool-content'>
              <div className='tool-preview-image'>
                <PaletteMockup />
                <div className='preview-overlay'>
                  <a className='ant-btn ant-btn-primary' href='https://palettes.desi8n.com' target='_blank' rel='noopener noreferrer'>
                    <i className='fab fa-telegram-plane'></i> Open Palettes
                  </a>
                </div>
              </div>
              <div className='tool-info'>
                <h3>Palettes</h3>
                <p>Comprehensive color palette explorer and manager for designers and developers.</p>
              </div>
            </div>
          </Col>

          <Col xs={{ span: 24 }} sm={{ span: 12 }} md={{ span: 12 }}>
            <div className='tool-content'>
              <div className='tool-preview-image'>
                <NpzMockup />
                <div className='preview-overlay'>
                  <a className='ant-btn ant-btn-primary' href='https://npzview.desi8n.com' target='_blank' rel='noopener noreferrer'>
                    <i className='fab fa-telegram-plane'></i> Open NPZ View
                  </a>
                </div>
              </div>
              <div className='tool-info'>
                <h3>NPZ View</h3>
                <p>Advanced dot npz file inspector with powerful data visualization capabilities.</p>
              </div>
            </div>
          </Col>
        </Row>
      </div>
    </div>
  );
}

export default AppTools;
